import RiceIndex from './src/RiceIndex.vue';

RiceIndex.install = function ( Vue ) {
    Vue.component(RiceIndex.name,RiceIndex);
}

export default RiceIndex;


//////////////////
// WEBPACK FOOTER
// ./packages/RiceIndex/index.js
// module id = null
// module chunks = 